import styled from "styled-components";
import theme from "../../../../styles/theme";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f8f9fa;
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
  overflow-y: auto;
  height: fit-content;
`;

export const LogoImage = styled.img`
  width: 100px;
  margin-bottom: 24px;
`;

export const Title = styled.h1`
  font-family: "Roboto", sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #202124;
  margin-bottom: 8px;
  text-align: center;
`;

export const Subtitle = styled.p`
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  color: #5f6368;
  margin-bottom: 40px;
  text-align: center;
`;

export const ProfilesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
  width: 100%;
  max-width: 900px;
  margin-bottom: 40px;
  @media (${theme.devices.tablet}) {
    grid-template-columns: 1fr;
  }
`;

export const ProfileCard = styled.button<{ $isSelected: boolean }>`
  font-family: "Roboto", sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 24px;
  border-radius: 12px;
  border: 2px solid
    ${(props) => (props.$isSelected ? theme.colors.blue.primary : "#dadce0")};
  background-color: ${(props) => (props.$isSelected ? "#f3f8ff" : "#ffffff")};
  cursor: pointer;
  text-align: center;
  transition: all 0.2s ease-in-out;
  box-shadow: ${(props) =>
    props.$isSelected
      ? "0 4px 12px rgba(66, 133, 244, 0.2)"
      : "0 2px 4px rgba(0, 0, 0, 0.05)"};

  &:hover {
    border-color: ${theme.colors.blue.primary};
    transform: translateY(-2px);
  }

  .icon {
    color: ${(props) =>
      props.$isSelected ? theme.colors.blue.primary : "#5f6368"};
    font-size: 56px;
  }

  .name {
    font-size: 18px;
    font-weight: 500;
    color: #202124;
  }

  .email {
    font-size: 14px;
    color: #5f6368;
  }
`;

export const ActionButton = styled.button`
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: white;
  background-color: #4285f4;
  padding: 12px 32px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover:not(:disabled) {
    background-color: #3367d6;
  }

  &:disabled {
    background-color: #e0e0e0;
    cursor: not-allowed;
  }
`;
